export const rodeoProductView = (productMap, variantId) => {
  const product = productMap.byVariantId[variantId]
  const product_id = product?.productId?.decoded
  const price = product?.pricing?.oneTime?.price
  const title = product?.title
  const productUrl = `${window.location.origin}/products/${product?.slug}`

  // When the product page loads or the product is viewed:
  const viewedProduct = {
    productDetails: {
      id: product_id,
      title,
      price,
      url: productUrl
    }
  }

  if (window && window.RodeoAnalytics) {
    window.RodeoAnalytics.publish('product_viewed', viewedProduct)
  }
}

export const rodeoAddToCart = (
  productMap: any,
  variantId: string,
  quantity: number,
  unitPrice: number
) => {
  const product = productMap.byVariantId[variantId]
  const product_id = product.productId.decoded
  const item_price = unitPrice
  const productUrl = `${window.location.origin}/products/${product.slug}`
  // When a product is added to the cart:
  const cartEvent = {
    productDetails: {
      id: product_id,
      title: product.title,
      price: unitPrice,
      url: productUrl
    },
    quantity,
    cost: {
      amount: item_price * quantity
    }
  }

  if (window && window.RodeoAnalytics) {
    // Call the function to track the event
    window.RodeoAnalytics.publish('product_added_to_cart', cartEvent)
  }
}
